/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_RemoveInputs */

const cs_chat_attach_remove = /** @type {(inputs: Chat_Attach_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrat přílohu`)
};

const en_chat_attach_remove = /** @type {(inputs: Chat_Attach_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove attachment`)
};

/**
* | output |
* | --- |
* | "Remove attachment" |
*
* @param {Chat_Attach_RemoveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_remove = /** @type {((inputs?: Chat_Attach_RemoveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_RemoveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_remove(inputs)
	return cs_chat_attach_remove(inputs)
});